import React, { useState } from "react";
import ProfileImg from "../../../assets/images/profileImage.png";
import { connect } from "react-redux";
import { RootState } from "../../../models/RootState";
import { UserDetails } from "../../../models/UserDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import "./MyProfile.scss"
import CloseIcon from '@mui/icons-material/Close';
import Dialog from "@mui/material/Dialog";
import { loadColorConfig } from "../../../constants/common";
import { toast } from "react-toastify";
import API from "../../../services";
import { setUserThumbnail, setUserName, setUserDetails } from "../../../store/authReducer";
import CreateRoundedIcon from '@mui/icons-material/CreateRounded';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CSK from "../../../assets/images/csk.svg";
import DC from "../../../assets/images/dc.svg";
import GT from "../../../assets/images/gt.svg";
import KKR from "../../../assets/images/kkr.svg";
import LSG from "../../../assets/images/lsg.svg";
import MI from "../../../assets/images/mi.svg";
import PK from "../../../assets/images/pk.svg";
import RR from "../../../assets/images/rr.svg";
import RCB from "../../../assets/images/rcb.svg";
import SRH from "../../../assets/images/srh.svg";


export const themes = {
    blue: {
        inputboxColor: '#1C3234',
        borderColor: '#21ACB9',
        meitmsColor: '#21ACB950',
        meicnbgColor: '#21ACB930',
        appbgColor: '#051314',
        headerColor: '#2E4C4E',
        filterColor: 'invert(53%) sepia(92%) saturate(369%) hue-rotate(137deg) brightness(89%) contrast(93%)',
        tablebg: '#123D46',
        tableHeader: '#0D2A2F',
        tableHeadCellBorder: '#1BC0D2',
        marketTableBg: '#204E55',
        backgroundCtnGradient: '#0B1F23',
        ionColorPrimary: '#21ACB9',
        teamInfoBackground: '#1E5661',
        inputBackgroundColor: '#15353A',
        inputTextColor: '#A3ECF1'
    },
    purple: {
        inputboxColor: '#272733',
        borderColor: '#B64FF6',
        meitmsColor: '#B64FF650',
        meicnbgColor: '#B64FF630',
        appbgColor: '#190C21',
        headerColor: '#412553',
        filterColor: 'invert(53%) sepia(74%) saturate(6142%) hue-rotate(255deg) brightness(102%) contrast(93%)',
        tablebg: '#341B4B',
        tableHeader: '#290E3C',
        tableHeadCellBorder: '#8C28C9',
        marketTableBg: '#482D62',
        backgroundCtnGradient: '#1D0F2B',
        ionColorPrimary: '#B64FF6',
        teamInfoBackground: '#722E8F',
        inputBackgroundColor: '#2A1B37',
        inputTextColor: '#E0B3FF'
    },
    green: {
        inputboxColor: '#25392E',
        borderColor: '#59DF91',
        meitmsColor: '#59DF9150',
        meicnbgColor: '#59DF9130',
        appbgColor: '#08160E',
        headerColor: '#294A37',
        filterColor: 'invert(67%) sepia(90%) saturate(276%) hue-rotate(90deg) brightness(97%) contrast(88%)',
        tablebg: '#123826',
        tableHeader: '#0C2418',
        tableHeadCellBorder: '#38B76C',
        marketTableBg: '#1F4F36',
        backgroundCtnGradient: '#0A1E14',
        ionColorPrimary: '#59DF91',
        teamInfoBackground: '#1D7A48',
        inputBackgroundColor: '#1A3023',
        inputTextColor: '#A7F2C2'
    },
    yellow: {
        inputboxColor: '#28261A',
        borderColor: '#B29B35',
        meitmsColor: '#B29B3550',
        meicnbgColor: '#B29B3530',
        appbgColor: '#0E0D04',
        headerColor: '#3F3C20',
        filterColor: 'invert(62%) sepia(30%) saturate(928%) hue-rotate(12deg) brightness(95%) contrast(81%)',
        tablebg: '#3A3415',
        tableHeader: '#2B260F',
        tableHeadCellBorder: '#8F7A29',
        marketTableBg: '#4E441B',
        backgroundCtnGradient: '#1E1A0A',
        ionColorPrimary: '#B29B35',
        teamInfoBackground: '#7A6925',
        inputBackgroundColor: '#2F2A12',
        inputTextColor: '#F2E3A7'
    },
    orange: {
        inputboxColor: '#3C1F18',
        borderColor: '#FF6843',
        meitmsColor: '#FF684350',
        meicnbgColor: '#FF684330',
        appbgColor: '#0E0604',
        headerColor: '#503129',
        filterColor: 'invert(48%) sepia(47%) saturate(1188%) hue-rotate(329deg) brightness(102%) contrast(101%)',
        tablebg: '#4A2219',
        tableHeader: '#3A1912',
        tableHeadCellBorder: '#D95634',
        marketTableBg: '#5C2D20',
        backgroundCtnGradient: '#21110C',
        ionColorPrimary: '#FF6843',
        teamInfoBackground: '#A84129',
        inputBackgroundColor: '#331B14',
        inputTextColor: '#FFB89E'
    },

    CSK: {
        inputboxColor: '#0D121F',
        borderColor: '#FFCB03',
        meitmsColor: '#FFCB0350',
        meicnbgColor: '#FFCB0330',
        appbgColor: '#000000',
        headerColor: '#161F35',
        filterColor: 'invert(70%) sepia(84%) saturate(924%) hue-rotate(357deg) brightness(106%) contrast(100%)',
        tablebg: '#4B3A1B',
        tableHeader: '#3C2E0E',
        tableHeadCellBorder: '#D9A400',
        marketTableBg: '#62502D',
        backgroundCtnGradient: '#2B1F0F',
        ionColorPrimary: '#FFCB03',
        teamInfoBackground: '#8F6E2E',
        inputBackgroundColor: '#37301B',
        inputTextColor: '#FFE6A3'
    },

    DC: {
        inputboxColor: '#131A2C',
        borderColor: '#B9251C',
        meitmsColor: '#B9251C50',
        meicnbgColor: '#B9251C30',
        appbgColor: '#000000',
        headerColor: '#161F35',
        filterColor: 'invert(26%) sepia(37%) saturate(5249%) hue-rotate(348deg) brightness(73%) contrast(97%)',
        tablebg: '#4B1B1E',
        tableHeader: '#3C0E12',
        tableHeadCellBorder: '#C92828',
        marketTableBg: '#622D2F',
        backgroundCtnGradient: '#2B0F10',
        ionColorPrimary: '#B9251C',
        teamInfoBackground: '#8F2E31',
        inputBackgroundColor: '#371B1D',
        inputTextColor: '#FFC3B3'
    },

    GT: {
        inputboxColor: '#0D1A31',
        borderColor: '#77C7F2',
        meitmsColor: '#77C7F250',
        meicnbgColor: '#77C7F230',
        appbgColor: '#000000',
        headerColor: '#203A69',
        filterColor: 'invert(76%) sepia(10%) saturate(2054%) hue-rotate(168deg) brightness(95%) contrast(101%)',
        tablebg: '#1B3B4B',
        tableHeader: '#0E2C3C',
        tableHeadCellBorder: '#28A1C9',
        marketTableBg: '#2D4F62',
        backgroundCtnGradient: '#0F1F2B',
        ionColorPrimary: '#77C7F2',
        teamInfoBackground: '#2E6A8F',
        inputBackgroundColor: '#1B2A37',
        inputTextColor: '#B3E6FF'
    },

    KKR: {
        inputboxColor: '#433878',
        borderColor: '#ECC542',
        meitmsColor: '#ECC54250',
        meicnbgColor: '#ECC54230',
        appbgColor: '#000000',
        headerColor: '#2B234E',
        filterColor: 'invert(87%) sepia(48%) saturate(707%) hue-rotate(334deg) brightness(93%) contrast(99%)',
        tablebg: '#28204B',
        tableHeader: '#1E1738',
        tableHeadCellBorder: '#ECC542',
        marketTableBg: '#3A3162',
        backgroundCtnGradient: '#1A132F',
        ionColorPrimary: '#ECC542',
        teamInfoBackground: '#4B3B8F',
        inputBackgroundColor: '#1B1537',
        inputTextColor: '#FCEAA3'
    },

    LSG: {
        inputboxColor: '#001538',
        borderColor: '#0548BC',
        meitmsColor: '#0548BC50',
        meicnbgColor: '#0548BC50',
        appbgColor: '#000000',
        headerColor: '#002462',
        filterColor: 'invert(14%) sepia(54%) saturate(6208%) hue-rotate(216deg) brightness(98%) contrast(96%)',
        tablebg: '#0548BC',
        tableHeader: '#04308A',
        tableHeadCellBorder: '#F28C28',
        marketTableBg: '#0A5ED1',
        backgroundCtnGradient: '#021E4F',
        ionColorPrimary: '#0548BC',
        teamInfoBackground: '#1560D4',
        inputBackgroundColor: '#0B2E6A',
        inputTextColor: '#FFD699'
    },

    MI: {
        inputboxColor: '#0B1E41',
        borderColor: '#2C6AB1',
        meitmsColor: '#2C6AB150',
        meicnbgColor: '#2C6AB130',
        appbgColor: '#000000',
        headerColor: '#143776',
        filterColor: 'invert(38%) sepia(13%) saturate(3374%) hue-rotate(175deg) brightness(94%) contrast(89%)',
        tablebg: '#2C6AB1',
        tableHeader: '#1F4D87',
        tableHeadCellBorder: '#F2A20C',
        marketTableBg: '#3B7EC9',
        backgroundCtnGradient: '#13375E',
        ionColorPrimary: '#2C6AB1',
        teamInfoBackground: '#4180C9',
        inputBackgroundColor: '#1A3966',
        inputTextColor: '#FFD580'
    },

    PK: {
        inputboxColor: '#17203F',
        borderColor: '#D83C42',
        meitmsColor: '#D83C4250',
        meicnbgColor: '#D83C4230',
        appbgColor: '#000000',
        headerColor: '#2C3C76',
        filterColor: ' invert(25%) sepia(100%) saturate(1374%) hue-rotate(333deg) brightness(100%) contrast(90%)',
        tablebg: '#D83C42',
        tableHeader: '#A52C30',
        tableHeadCellBorder: '#EFC75E',
        marketTableBg: '#E04E54',
        backgroundCtnGradient: '#731F22',
        ionColorPrimary: '#D83C42',
        teamInfoBackground: '#B83237',
        inputBackgroundColor: '#5A1A1D',
        inputTextColor: '#FFE0A3'
    },

    RR: {
        inputboxColor: '#052045',
        borderColor: '#EB83B5',
        meitmsColor: '#EB83B550',
        meicnbgColor: '#EB83B530',
        appbgColor: '#000000',
        headerColor: '#0C3A78',
        filterColor: 'invert(81%) sepia(51%) saturate(2810%) hue-rotate(288deg) brightness(99%) contrast(86%)',
        tablebg: '#103564',
        tableHeader: '#092754',
        tableHeadCellBorder: '#EB83B5',
        marketTableBg: '#154481',
        backgroundCtnGradient: '#031E44',
        ionColorPrimary: '#EB83B5',
        teamInfoBackground: '#8C4E7A',
        inputBackgroundColor: '#0F2A57',
        inputTextColor: '#FFD2E6'
    },

    RCB: {
        inputboxColor: '#242424',
        borderColor: '#97282C',
        meitmsColor: '#97282C50',
        meicnbgColor: '#97282C30',
        appbgColor: '#000000',
        headerColor: '#454545',
        filterColor: 'invert(12%) sepia(98%) saturate(2613%) hue-rotate(344deg) brightness(98%) contrast(83%)',
        tablebg: '#3A1C1D',
        tableHeader: '#2A1213',
        tableHeadCellBorder: '#97282C',
        marketTableBg: '#5A2A2D',
        backgroundCtnGradient: '#1E0D0E',
        ionColorPrimary: '#97282C',
        teamInfoBackground: '#7D3E40',
        inputBackgroundColor: '#302020',
        inputTextColor: '#FFB3B5'
    },

    SRH: {
        inputboxColor: '#5A2025',
        borderColor: '#F26522',
        meitmsColor: '#F2652250',
        meicnbgColor: '#F2652230',
        appbgColor: '#000000',
        headerColor: '#722425',
        filterColor: 'invert(51%) sepia(81%) saturate(3349%) hue-rotate(349deg) brightness(99%) contrast(92%)',
        tablebg: '#742A1E',
        tableHeader: '#5A1F18',
        tableHeadCellBorder: '#F26522',
        marketTableBg: '#9C3E2B',
        backgroundCtnGradient: '#33120E',
        ionColorPrimary: '#F26522',
        teamInfoBackground: '#B84D2F',
        inputBackgroundColor: '#621F14',
        inputTextColor: '#FFD1B3'
    }
};

type ProfileProps = {
    userDetails: UserDetails;
    userThumbnail: any;
    setUserThumbnail: (data: any) => void;
    setUserName: (data: any) => void;
    setUserDetails: (data: any) => void;
}

const MyProfile: React.FC<ProfileProps> = ({ userDetails, userThumbnail, setUserThumbnail, setUserName, setUserDetails }) => {

    const navigate = useNavigate();
    const [showAvatars, setShowAvatars] = useState<any>(false);
    const [selectedImg, setSelectedImg] = useState<any>("1");
    const [nickName, setNickName] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [openName, setOpenName] = useState<any>(false);

    const getAssetImage = (imageName: any) => {
        return require(`../../../assets/images/av${imageName}.png`).default;
    };

    const images = ["1", "2", "3", "4", "5", "6", "7", "27", "28", "29", "30", "31", "32", "33", "57", "58", "59", "60"];


    const handleThemeChange = (themeName: keyof typeof themes) => {
        const selectedTheme = themes[themeName];

        if (selectedTheme) {
            changeTheme(themeName, selectedTheme);
        } else {
            console.error('Theme not found');
        }
    };

    const changeTheme = async (theme: any, selectedTheme: any) => {
        let response: any;
        try {
            response = await API.post(`/users/change-user-theme`, {
                theme: theme
            });
        } catch (e) {
            return;
        }
        if (response.data?.status !== "RS_OK") {
            toast.error(response.data?.errorDescription);
        } else {
            toast.success("Theme Changed Successfully")
            loadColorConfig(selectedTheme);
            getRefId();
        }
    }

    const onChangeProfile = () => {
        let profile = `https://cdn.dreamdelhi.com/strike/av${selectedImg}.png`;
        changeProfilePic(profile);
    }


    const changeProfilePic = async (profile: any) => {
        let response: any;
        try {
            response = await API.post(`/users/change-user-thumbnail`, {
                thumbnail: profile
            });
        } catch (e) {
            return;
        }
        if (response.data?.status !== "RS_OK") {
            toast.error(response.data?.errorDescription);
        } else {
            setUserThumbnail(profile);
            toast.success("Avatar Changed Successfully");
            setShowAvatars(false);
        }
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await API.post(`/users/change-user`, {
                userName: nickName,
            });

            const data = await response.data;
            if (data?.status !== "RS_OK") {
                toast.error(data?.errorDescription);
            } else {
                setUserName(nickName);
                toast.success("Name Changed Successfully");
            }
            setOpenName(false);
        } catch (error) {
            console.log("There was a problem with the fetch operation.");
        } finally {
            setLoading(false);
        }
    };

    const getRefId = async () => {
        try {
            //   setAmtLoading(true);
            const userKey = sessionStorage.getItem("userKey");
            if (!userKey) {
                console.error("User ID not found in session storage");
                return;
            }
            const response = await API.post(`/users/get-user-details`, {
                userKey: userKey,
            });

            if (!response || response.data.status !== "RS_OK") {
                console.error("Error retrieving user details or invalid status");
                return;
            }

            const fetchedUserDetails: UserDetails = response.data?.userDetails;

            if (fetchedUserDetails) {
                setUserDetails(fetchedUserDetails);
            } else {
                console.error("User details not found in response");
            }
            //   setAmtLoading(false)
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
    };

    const teams: Array<{ name: "CSK" | "DC" | "GT" | "KKR" | "LSG" | "MI" | "PK" | "RR" | "RCB" | "SRH"; logo: string }> = [
        { name: "CSK", logo: CSK },
        { name: "DC", logo: DC },
        { name: "GT", logo: GT },
        { name: "KKR", logo: KKR },
        { name: "LSG", logo: LSG },
        { name: "MI", logo: MI },
        { name: "PK", logo: PK },
        { name: "RR", logo: RR },
        { name: "RCB", logo: RCB },
        { name: "SRH", logo: SRH },
    ];

    const handleBackClick = () => {
        navigate(-1);
    };
    return (
        <>
            <div className="flex flex-col items-center px-3 mt-4 w-full pb-[7rem] py-[4rem] my-profile">
                <header className="flex gap-3 items-center self-start text-base font-medium text-center text-white mb-[0.5rem]">
                    <div>
                        <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                            onClick={() => handleBackClick()}
                        >
                            <ArrowBackIcon
                                className="text-border-color aspect-square w-[18px]"
                                style={{ width: '20px', height: '20px' }}
                            />
                        </div>
                    </div>
                    <h2 className="self-stretch my-auto">My Profile</h2>
                </header>
                <img
                    loading="lazy"
                    src={userThumbnail === "" ? ProfileImg : userThumbnail}
                    alt="Profile picture"
                    className="object-contain flex items-center max-w-full aspect-square w-[100px]"
                />

                <div className="border border-solid text-sm bg-inputbox-color border-border-color m-1 py-[2px] px-[5px] rounded-2xl"
                    onClick={() => setShowAvatars(true)}
                >
                    Change Avatar
                </div>
                <div className="flex">
                    <h1 className="mt-3 text-base text-center text-white">{userDetails?.UserName}</h1>
                    <CreateRoundedIcon className="mt-3 ml-2"
                        onClick={() => setOpenName(true)} />
                </div>
                <p className="mt-1 text-sm text-center text-zinc-400">{userDetails.MobileNumber}</p>
                <p className="mt-1 text-sm text-center text-zinc-400">{userDetails.EmailId}</p>
                <div className="mt-4">Change Theme</div>
                <div className="grid w-full grid-cols-3 grid gap-2 mt-2 text-sm">
                    <button
                        onClick={() => handleThemeChange('blue')}
                        className="p-2 py-1 rounded-full bg-[#1C3234] text-text-color border border-[#21ACB9]"
                    >
                        Blue
                    </button>
                    <button
                        onClick={() => handleThemeChange('purple')}
                        className="p-2 py-1 rounded-full bg-[#272733] text-text-color border border-[#B64FF6]"
                    >
                        Purple
                    </button>
                    <button
                        onClick={() => handleThemeChange('green')}
                        className="p-2 py-1 rounded-full bg-[#25392E] text-text-color border border-[#59DF91]"
                    >
                        Green
                    </button>
                </div>
                <div className="grid w-8/12 grid-cols-2 grid gap-2 mt-2 text-sm">
                    <button
                        onClick={() => handleThemeChange('yellow')}
                        className="p-2 py-1 rounded-full bg-[#28261A] text-text-color border border-[#B29B35]"
                    >
                        Yellow
                    </button>
                    <button
                        onClick={() => handleThemeChange('orange')}
                        className="p-2 py-1 rounded-full bg-[#3C1F18] text-text-color border border-[#FF6843]"
                    >
                        Orange
                    </button>
                </div>
                <div>
                    <div className="mt-4 text-center">Game time! Wear your team's look</div>
                    <div className="grid w-full grid-cols-3 gap-2 mt-2 text-sm">
                        {teams.map((team) => (
                            <button
                                key={team.name}
                                onClick={() => handleThemeChange(team.name)}
                                className={`p-1 border-2 rounded-lg ${userDetails.Theme === team.name ? "border-green-500 bg-green-100" : "border-gray-300 bg-white"
                                    }`}
                            >
                                <img src={team.logo} alt={team.name} />
                            </button>
                        ))}
                    </div>
                </div>
            </div >

            {
                showAvatars && (
                    <Dialog
                        fullScreen={false}
                        open={showAvatars}
                        onClose={() => setShowAvatars(false)}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: '5rem'
                            }
                        }}
                        className="my-profile"
                    >
                        <div className="dialog-bg bg-inputbox-color relative p-4">
                            <div className="flex items-center justify-between pb-2">
                                <div className="text-xl">
                                    Choose Avatar
                                </div>
                                <CloseIcon
                                    className="absolute top-3 right-3 text-white text-2xl font-semibold"
                                    onClick={() => setShowAvatars(false)}
                                />
                            </div>
                            <div className="dg-main">
                                <div className="av-ctn">
                                    {images.map((imageName, index) => (
                                        <div key={index} className={`image-container rounded-full ${selectedImg === imageName ? "bg-border-color" : ""}`}
                                            onClick={() => setSelectedImg(imageName)}
                                        >
                                            <img
                                                // src={`../../../assets/images/av${imageName}.png`}
                                                src={`https://cdn.dreamdelhi.com/strike/av${imageName}.png`}
                                                alt={`Image ${index + 1}`}
                                                className="w-full h-auto object-cover rounded-lg"
                                                decoding="async"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="flex justify-around mt-4 pt-2">
                                <button
                                    type="button"
                                    className="p-2 w-[30%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                                    onClick={onChangeProfile}
                                >
                                    {"Save"}
                                </button>
                                <button
                                    type="button"
                                    className="p-2 w-[30%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                                    onClick={() => setShowAvatars(false)}
                                >
                                    {"Cancel"}
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )
            }

            {
                openName && (
                    <Dialog
                        fullScreen={false}
                        open={openName}
                        onClose={() => setOpenName(false)}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: '5rem'
                            }
                        }}
                    >
                        <div className="dialog-bg bg-inputbox-color relative p-4">
                            <CloseIcon
                                className="absolute top-3 right-3 text-white text-2xl font-semibold"
                                onClick={() => setOpenName(false)}
                            />
                            <div>
                                <div>
                                    Change User Name
                                </div>
                                <div>
                                    <>
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                handleSubmit();
                                            }}
                                            className="mt-4 w-full max-w-md mx-auto"
                                        >
                                            <div className="mb-4">
                                                <input
                                                    type="text"
                                                    className="px-4 py-3 mt-2.5 w-full text-sm font-medium text-white placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem]"
                                                    id="userName"
                                                    placeholder="Enter Name"
                                                    onChange={(e) => setNickName(e.target.value)}
                                                />
                                            </div>
                                            <div className="flex gap-2">
                                                <button
                                                    type="button"
                                                    className="p-2.5 w-full text-sm text-white whitespace-nowrap bg-red-600 rounded-lg border border-red-600 border-solid leading-[1.4rem]"
                                                    onClick={() => setOpenName(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className={`p-2.5 w-full text-sm text-white whitespace-nowrap bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] ${loading ? "opacity-50" : ""
                                                        }`}
                                                    disabled={loading}
                                                >
                                                    <span className="submit-label">
                                                        {loading ? "Processing..." : "Submit"}
                                                    </span>
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                )
            }
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        userDetails: state.userDetails?.userDetails,
        userThumbnail: state.userDetails.Thumbnail,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        setUserThumbnail: (data: any) => {
            dispatch(setUserThumbnail(data));
        },
        setUserName: (data: any) => {
            dispatch(setUserName(data));
        },
        setUserDetails: (data: any) => {
            dispatch(setUserDetails(data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);
